import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-415ebf24"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "field-wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.field.type)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(), _createBlock(_resolveDynamicComponent($setup.getComponent($props.field)), {
          name: $props.field.key,
          label: $props.field.label,
          placeholder: $props.field.placeholder,
          title: $props.field.label,
          description: $props.field.placeholder,
          disabled: $props.disabled,
          required: $props.required,
          options: $props.field.options,
          datasource: $props.field.datasourceApi,
          directlyEditable: $props.field.isDirectlyEditable,
          nameKey: $props.field.optionNameKey,
          valueKey: $props.field.optionValueKey,
          parentKey: $props.field.parentFieldKey,
          parentValue: $props.parentValue,
          certRequired: $props.field.isCertRequired,
          authRequiredForEditYn: $props.authRequiredForEditYn,
          timerStatus: $props.field.timerStatus,
          isEdited: $props.field.isEdited,
          rules: $props.rules,
          value: $setup.inputValue,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($setup.inputValue) = $event)),
          onUpdateChildFieldValidity: $setup.updateChildFieldValidity,
          onOnUpdatedOptions: $setup.updateOptions,
          onUpdateChildTimerStatus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('updateChildTimerStatus', $event))),
          onUpdateTimerStatus: $setup.updateTimerStatus,
          onVerificationSuccess: _cache[2] || (_cache[2] = ($event: any) => ($setup.updateAllParentFieldValidity(false))),
          onUpdateVerficationCodeSent: $setup.updateVerficationCodeSent
        }, null, 40 /* PROPS, NEED_HYDRATION */, ["name", "label", "placeholder", "title", "description", "disabled", "required", "options", "datasource", "directlyEditable", "nameKey", "valueKey", "parentKey", "parentValue", "certRequired", "authRequiredForEditYn", "timerStatus", "isEdited", "rules", "value"]))
      ]))
    : _createCommentVNode("v-if", true)
}